import React, { useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Message from 'components/_core/Message';
import LoaderButton from 'components/_core/LoaderButton';

import { fetchPricing, upgradeToAnnual } from 'redux/actions';

import InlineLoader from 'components/_core/InlineLoader';
import { formatPrice } from 'components/JoinModal/PlanPrice';

const UpgradeSubscription = () => {
    const dispatch = useDispatch();
    const processing = useSelector(state => state.user.upgradeSubscription.processing);
    const error = useSelector(state => state.user.upgradeSubscription.error);
    const subState = useSelector(state => state.user.subscription.state) || {};
    const prices = useSelector(state => state.pricing.prices);
    const fetched = useSelector(state => state.pricing.fetched);

    useEffect(() => {
        if (!fetched) {
            dispatch(fetchPricing());
        }
    }, [dispatch, fetched]);
    
    const fullPrice = useMemo(() => {
        if (!prices) return 0;
        return prices.monthly?.sale ? prices.monthly.sale.amount * 12 : prices.monthly?.default.amount * 12;
    }, [prices]);

    const annualPrice = useMemo(() => {
        if (!prices) return 0;
        return prices.annual?.sale ? prices.annual.sale : prices.annual?.default;
    }, [prices]);

    const savings = useMemo(() => {
        return {
            amount: Math.floor(fullPrice - annualPrice.amount),
            format: annualPrice.format
        };
    }, [fullPrice, annualPrice]);

    const go = useCallback(() => {
        if (window.confirm(`Nice choice, you’ll save ${formatPrice(savings)} per year! When you confirm, you will be charged ${formatPrice(annualPrice)}, and you will lock that price in forever.`)) {
            dispatch(upgradeToAnnual(subState.subscription_id));
        }
    }, [dispatch, subState.subscription_id, savings, annualPrice]);

    if (subState.plan === 'Annual') {
        return null;
    }

    if (error) {
        return <Message error>Error upgrading. Please contact support.</Message>
    }

    if (!fetched) {
        return <InlineLoader />;
    }
    
    return (
        <>
            <LoaderButton disabled={processing} loading={processing} style={{ marginTop: '20px' }} orange onClick={go}>Upgrade to Annual Billing for {formatPrice(annualPrice)} / year</LoaderButton>
        </>
    );
};

export default UpgradeSubscription;
